import { Icon } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { withTheme } from 'styled-components';

import { MoreInformationModal } from '../MoreInformationModals';

const GiftBasketMoreInformationModal = ({ theme, isModalOpen, onRequestClose }) => {
  const { t } = useTranslation();
  return (
    <MoreInformationModal
      isModalOpen={isModalOpen}
      onRequestClose={onRequestClose}
      contentList={[
        {
          title: t('giftBasket'),
          description: t('giftBasketDesc'),
          icon: (
            <Icon
              name="gift-box"
              color="var(--color-accent-primary-default)"
              style={{ marginRight: 16, marginTop: 4 }}
            />
          ),
          images: [
            {
              src: theme.images.giftBasketMoreInformation11,
              alt: t('giftBasket')
            }
          ]
        },
        {
          title: t('costEstimate'),
          description: t('costEstimateDesc'),
          icon: (
            <Icon
              name="cost-estimate"
              color="var(--color-accent-primary-default)"
              style={{ marginRight: 16, marginTop: 4 }}
            />
          ),
          images: [
            {
              src: theme.images.giftBasketMoreInformation12,
              alt: t('costEstimate')
            }
          ]
        }
      ]}
    />
  );
};

export default withTheme(GiftBasketMoreInformationModal);
